import { GameStatues, IGame, IGameAttendances, IPlayer } from "@grassrootly/api";

export function isAttending(game: IGame, player: IPlayer): boolean {
  return !!game.attendees.find((a) => a.player_id == player.id && a.attended);
}

export function hasChoosenAttendance(game: IGame, player: IPlayer): boolean {
  return !!game.attendees.find((a) => a.player_id == player.id && a.attended != null);
}

export function isFinished(game: IGame): boolean {
  return [GameStatues.FINISHED, GameStatues.FINALIZED].indexOf(game.status) > -1;
}

export function getGameMVP(attendees: IGameAttendances[]): IGameAttendances {
  // todo: better sorting
  return attendees.filter((a) => a.attended).sort((a, b) => b.rating - a.rating)[/* .sort((a, b) => {
      let srt = b.points_earned - a.points_earned;
      if (srt == 0) {
        srt = b.goals_scored - a.goals_scored;
      }
      return srt;
    }) */ 0];
}

export function hasScoredOrAssisted(player: IGameAttendances): boolean {
  return !!player.assists_made || !!player.goals_scored;
}
